import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { normalizeSocialLink as m } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as s } from "../../utils/get-social-link-icon.mjs";
import d from "../../../components/store-image.mjs";
import { useStore as n } from "../../../store/index.mjs";
import { StoreImageEnum as p } from "../../../enums/store-image-enum.mjs";
const h = ({ profile: r, socialLinks: l }) => {
  var i;
  const { locale: o } = n();
  return /* @__PURE__ */ e(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      className: "mx-5 w-full overflow-hidden py-9 sm:max-w-xl ",
      style: { width: "calc(100% - 2.5rem)" },
      children: /* @__PURE__ */ a("div", { className: "border-THEME-primary/50 relative flex rounded-b-lg border-2 border-t-0", children: [
        /* @__PURE__ */ e("div", { className: "border-THEME-primary absolute -left-[15%] top-[20%] -z-10 h-[60%] w-[130%] rounded-t-full border-[15px] border-b-0 blur-[20px] sm:-left-[15%] sm:top-[25%] sm:h-[65%] sm:w-[130%]" }),
        /* @__PURE__ */ e("div", { className: "from-THEME-primary/30 to -z-1 absolute -inset-x-[1px] -bottom-[0.5px] top-0 rounded-b-lg bg-gradient-to-t to-transparent opacity-70" }),
        /* @__PURE__ */ e("div", { className: "border-THEME-tertiary absolute inset-y-0 -left-[3px] bottom-[3px] z-0 border-l-4" }),
        /* @__PURE__ */ e(
          "div",
          {
            className: "z-1 absolute inset-y-0 -left-[2px] bottom-[3px] border-l-2 opacity-50 md:-left-[1.5px]",
            style: {
              borderImage: "linear-gradient(to bottom, transparent, var(--THEME-primary)) 2"
            }
          }
        ),
        /* @__PURE__ */ e("div", { className: "border-THEME-tertiary absolute inset-y-0 -right-[3px] bottom-[3px] z-0 border-l-4" }),
        /* @__PURE__ */ e(
          "div",
          {
            className: "z-1 absolute inset-y-0 -right-[1.5px] bottom-[3px] border-l-2 opacity-50",
            style: {
              borderImage: "linear-gradient(to bottom, transparent, var(--THEME-primary)) 2"
            }
          }
        ),
        /* @__PURE__ */ a("div", { className: "flex w-full flex-col items-center justify-end gap-10 px-5 py-9", children: [
          /* @__PURE__ */ e("div", { className: "border-THEME-primary rounded-full border-[15px]", children: /* @__PURE__ */ e(
            d,
            {
              className: "rounded-full border-0 border-transparent",
              width: 149,
              height: 149,
              alt: r.sellerName,
              imageType: p.profile,
              src: (i = r.sellerPhoto) == null ? void 0 : i.path
            }
          ) }),
          /* @__PURE__ */ a("div", { className: "flex flex-col items-center", children: [
            /* @__PURE__ */ e(
              "h1",
              {
                id: "region-heading",
                lang: o,
                className: "text-THEME-text-primary break-all text-center text-[35px] font-bold leading-[45.57px]",
                children: r.sellerName
              }
            ),
            r.bio && /* @__PURE__ */ e(
              "span",
              {
                lang: o,
                className: "text-THEME-text-primary hyphens-auto mb-4 mt-2 text-center text-lg font-normal",
                children: r.bio
              }
            ),
            !!l.length && /* @__PURE__ */ e("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1", children: l.map((t) => /* @__PURE__ */ e(
              "a",
              {
                href: m(t),
                target: "_blank",
                rel: "noreferrer",
                className: "rounded-md p-1",
                "aria-label": t.type,
                children: s(t.type, "fill-THEME-text-primary")
              },
              t.type
            )) })
          ] })
        ] })
      ] })
    }
  );
};
export {
  h as ProfileCyberpunk
};
